import React from 'react';

export const ConnectionStatusGreat: React.FC = () => (
  <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      stroke='#00DDB5'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      d='M12 16v-5M7 16v-2M17 16V8'
    ></path>
  </svg>
);
